import Analytics from '../Analytics';

const useAnalytics = () => Analytics;

export default useAnalytics;
